/**
 * Chargement différé des vidéos de hero.
 *
 * Le rendu Liquid (snippets/montrelio-hero-video.liquid) pose une affiche fixe et
 * un <video> vide. Ce script attache la source une fois la page peinte, et
 * uniquement au <video> réellement visible : les variantes desktop et mobile
 * coexistent dans le DOM (masquées en CSS) et un `src` posé côté serveur les fait
 * toutes les deux télécharger.
 *
 * On s'abstient purement et simplement quand la vidéo n'est pas souhaitable :
 * animations réduites, économiseur de données, connexion lente. L'affiche reste
 * alors en place, ce qui est le comportement voulu et non une dégradation.
 */
(function () {
  const SELECTOR = 'video[data-mtr-hero-video]';

  function prefersNoVideo() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;

    const connection = navigator.connection;
    if (!connection) return false;
    if (connection.saveData) return true;
    return connection.effectiveType === '2g' || connection.effectiveType === 'slow-2g';
  }

  /**
   * Le point de rupture est déduit du rendu réel plutôt que d'un matchMedia
   * dupliqué : c'est le CSS du thème qui décide lequel des deux wrappers
   * s'affiche, et le recopier ici créerait deux sources de vérité.
   */
  function isVisible(video) {
    return video.offsetParent !== null || video.getClientRects().length > 0;
  }

  function activate(video) {
    if (video.dataset.mtrHeroLoaded === 'true') return;
    if (!isVisible(video)) return;

    const src = video.dataset.mtrSrc;
    if (!src) return;

    video.dataset.mtrHeroLoaded = 'true';
    video.muted = true;
    video.preload = 'auto';

    video.addEventListener(
      'playing',
      () => {
        video.classList.add('is-playing');
      },
      { once: true }
    );

    video.src = src;

    const attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(() => {
        // Lecture refusée (politique navigateur, onglet en arrière-plan) :
        // l'affiche reste visible, rien à réparer.
      });
    }
  }

  function activateAll(root) {
    if (prefersNoVideo()) return;
    (root || document).querySelectorAll(SELECTOR).forEach(activate);
  }

  function whenIdle(callback) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(callback, { timeout: 3000 });
    } else {
      setTimeout(callback, 200);
    }
  }

  function start() {
    whenIdle(() => activateAll());
  }

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start, { once: true });
  }

  // Le hero est re-rendu à chaque modification dans l'éditeur de thème, et le
  // changement d'orientation peut faire basculer le wrapper visible.
  document.addEventListener('shopify:section:load', (event) => activateAll(event.target));
  window.addEventListener('orientationchange', () => whenIdle(() => activateAll()));
})();
